module.exports = __webpack_public_path__ + "img/Group-275.e5beab34.svg";